export default __webpack_public_path__ + "static/everrise-ogp-7c79b71af3f98dd668a1220816de75fc.png";